import { GridValueFormatterParams } from '@mui/x-data-grid-pro'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'

export const soldServiceStatusValueFormatter = ({
  value,
}: GridValueFormatterParams): any => {
  switch (value) {
    case SOLD_SERVICE_STATUS.Completed:
      return 'Completed'
    case SOLD_SERVICE_STATUS.NotSent:
      return ''
    case SOLD_SERVICE_STATUS.Processing:
      return 'Processing'
    case SOLD_SERVICE_STATUS.Revise:
      return 'Revise'
    case SOLD_SERVICE_STATUS.Submitted:
      return 'Submitted'
  }
}
